import { render, staticRenderFns } from "./SearchBtn.vue?vue&type=template&id=086556b2&scoped=true"
import script from "./SearchBtn.vue?vue&type=script&lang=js"
export * from "./SearchBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086556b2",
  null
  
)

export default component.exports